<template>
  <div />
</template>

<script>
import { Notification } from '@/utils/notification'

export default {
  name: 'NotifierGrowl',
  mounted() {
    this.$store.commit('addToBus', this)
    // this.$store.commit("sendNotification", {
    //   type: enums.notification.types.MESSAGE,
    //   msg: "This is a simple notice, that should notify us",
    //   sender: this,
    //   severity: enums.notification.severity.NOTICE,
    // });
    // this.$store.commit("sendNotification", {
    //   type: enums.notification.types.MESSAGE,
    //   msg: "This is a simple informational message, that should inform us",
    //   sender: this,
    //   severity: enums.notification.severity.INFO,
    // });
    // this.$store.commit("sendNotification", {
    //   type: enums.notification.types.ERROR,
    //   msg: "This is a simple error message",
    //   sender: this,
    //   severity: enums.notification.severity.NOTICE,
    // });
    // this.$store.commit("sendNotification", {
    //   type: enums.notification.types.NETWORK,
    //   msg: "UHHHH be careful with that, this is a warning mister",
    //   sender: this,
    //   severity: enums.notification.severity.WARNING,
    // });
  },
  beforeUnmount() {
    this.$store.commit('removeFromBus', this)
  },
  methods: {
    /**
     * This method takes a notification, formats it, and then displays a growler message of it
     */
    notify(note) {
      const send = new Notification(note)
      send.dispatch(this)
    },
  },
}
</script>

<style scoped lang="scss"></style>
